import { render, staticRenderFns } from "./DiagnosticGroups.vue?vue&type=template&id=7c21d919"
import script from "./DiagnosticGroups.vue?vue&type=script&lang=js"
export * from "./DiagnosticGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports